<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'PATH_SETTINGS' }
  ]"
></breadcrumbs>

<page-header title="PATH_SETTINGS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="PATH_CLIENT_BASE_URL"
        >{{ 'PATH_CLIENT_BASE_URL' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="PATH_CLIENT_BASE_URL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['PATH_CLIENT_BASE_URL'])"
          [ngClass]="{ 'is-danger': hasError('PATH_CLIENT_BASE_URL') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('PATH_CLIENT_BASE_URL')">
        {{ getError('PATH_CLIENT_BASE_URL') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PATH_IMAGE_UPLOAD">{{
        'PATH_IMAGE_UPLOAD' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="PATH_IMAGE_UPLOAD"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['PATH_IMAGE_UPLOAD'])"
          [ngClass]="{ 'is-danger': hasError('PATH_IMAGE_UPLOAD') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('PATH_IMAGE_UPLOAD')">
        {{ getError('PATH_IMAGE_UPLOAD') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="PATH_DELIVERY_CONFIRMATION_UPLOAD"
        >{{ 'PATH_DELIVERY_CONFIRMATION_UPLOAD' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="PATH_DELIVERY_CONFIRMATION_UPLOAD"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['PATH_DELIVERY_CONFIRMATION_UPLOAD'])"
          [ngClass]="{
            'is-danger': hasError('PATH_DELIVERY_CONFIRMATION_UPLOAD')
          }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('PATH_IMAGE_UPLOAD')">
        {{ getError('PATH_IMAGE_UPLOAD') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PATH_IMAGE_BASE_URL">{{
        'PATH_IMAGE_BASE_URL' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="PATH_IMAGE_BASE_URL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['PATH_IMAGE_BASE_URL'])"
          [ngClass]="{ 'is-danger': hasError('PATH_IMAGE_BASE_URL') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('PATH_IMAGE_BASE_URL')">
        {{ getError('PATH_IMAGE_BASE_URL') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PATH_RDN_GENERATION">{{
        'PATH_RDN_GENERATION' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="PATH_RDN_GENERATION"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['PATH_RDN_GENERATION'])"
          [ngClass]="{ 'is-danger': hasError('PATH_RDN_GENERATION') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('PATH_RDN_GENERATION')">
        {{ getError('PATH_RDN_GENERATION') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="PATH_DOCUMENT_UPLOAD"
        >{{ 'PATH_DOCUMENT_UPLOAD' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="PATH_DOCUMENT_UPLOAD"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['PATH_DOCUMENT_UPLOAD'])"
          [ngClass]="{ 'is-danger': hasError('PATH_DOCUMENT_UPLOAD') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('PATH_DOCUMENT_UPLOAD')">
        {{ getError('PATH_DOCUMENT_UPLOAD') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PATH_TEMP_FOLDER">{{
        'PATH_TEMP_FOLDER' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="PATH_TEMP_FOLDER"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['PATH_TEMP_FOLDER'])"
          [ngClass]="{ 'is-danger': hasError('PATH_TEMP_FOLDER') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('PATH_TEMP_FOLDER')">
        {{ getError('PATH_TEMP_FOLDER') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
